import * as actions from '../themes/redux/actions';
import * as homeActions from '../home/redux/apiCall';

import React, { useEffect, useState } from 'react';

import ApiUrls from '../../services/apiUrls';
import { AppData } from '../../services';
import GoogleMapReact from 'google-map-react';
import { Marker } from 'google-maps-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from './functions/getIcons/getIcons';

const data = [
	{
		title: 'santiago',
		active: true,
		subOffices: [
			{
				city: 'santiago',
				address: 'address',
				lat: '-33.456130',
				lng: '-70.688390',
			},
			{
				city: 'santiago',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
		],
	},

	{
		title: 'Sringar',
		subOffices: [
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
		],
	},

	{
		title: 'Ganderbal',
		subOffices: [
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
		],
	},

	{
		title: 'Baramulla',
		subOffices: [
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
		],
	},

	{
		title: 'Budgam',
		subOffices: [
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
		],
	},

	{
		title: 'Ganderxbal',
		subOffices: [
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
		],
	},

	{
		title: 'Baramulkla',
		subOffices: [
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
			{
				city: 'Sringar',
				address: 'address',
				lat: '3424',
				lng: '3434',
			},
		],
	},
];

const AnyReactComponent = ({ img }) => (
	<div>
		<img
			style={{
				display: 'inline-block',
				width: '20px',
			}}
			src={img}
		/>
	</div>
);

const ThemeFiveOfficeSection = props => {
	const [selectedOffice, setSelectedOffice] = useState({});
	const [offices, setOffices] = useState([]);
	const { operator } = props.home;
	console.log('props', props);

	const [latLong, setLatLong] = useState({
		lat: '-33.456130',
		long: '-70.688390',
	});

	// console.log('props================================', props);

	useEffect(() => {
		props.actions.apiCall({
			type: 'home',
			url: ApiUrls.officeDetails(),
			callback: res => onResponse(res),
		});
	}, []);

	const onResponse = res => {
		// console.log('onResponse', res);

		if (res && res.data && res.data.offices && res.data.offices.length > 0) {
			const data = res.data.offices.map((val, i) => {
				val.active = i === 0 ? true : false;
				return val;
			});
			setOffices(data);
			// console.log('insider', data);
			setSelectedOffice(data && data[0]);
			setLatLong({
				lat:
					data &&
					data[0].subOffices &&
					data[0].subOffices.length > 0 &&
					data[0].subOffices[0].lat &&
					data[0].subOffices[0].lat,
				long:
					data[0] &&
					data[0].subOffices &&
					data[0].subOffices.length > 0 &&
					data[0].subOffices[0].long &&
					data[0].subOffices[0].long,
			});
		}
	};

	const onSelect = item => {
		const data = offices.map((val, i) => {
			val.active = val.title === item.title ? true : false;
			return val;
		});
		setOffices(data);
		setSelectedOffice(item);
		setLatLong({
			lat:
				item &&
				item.subOffices &&
				item.subOffices.length > 0 &&
				item.subOffices[0].lat &&
				item.subOffices[0].lat,
			long:
				item &&
				item.subOffices &&
				item.subOffices.length > 0 &&
				item.subOffices[0].long &&
				item.subOffices[0].long,
		});
	};

	// console.log(selectedOffice, 'subOffices');

	const getDynamicStyling = (item, index) => {
		if (operator && operator.operator_name === 'jeldres') {
			if (item.active) {
				return {

					background: operator && operator.color_codes.secondary_off_bg,
				};
			} else {
				return {

					background: operator && operator.color_codes.primary_off_bg,
				};
			}
		}

		return {
			color: operator && operator.color_codes ? operator.color_codes.secondary_text_color : '#000',
			background: item.active
				? operator.color_codes.selected_off_bg
				: operator.color_codes.primary_off_bg,
		};
	};

	const getActiveColor = () => {
		return operator.operator_name === 'jeldres' ? '#fff' : '#000';
	};

	const getInActiveColor = () => {
		return operator.operator_name === 'jeldres' ? '#fff' : '#fff';
	};
	console.log('getActiveColor', getActiveColor());
	return (
		<div className="themes-theme-five-office-section">
			<div className="new-container">
				<div className="offices">
					<ul
						className="office__list"
						style={{
							background: operator && operator.operator_name === 'jeldres' ? '#ecdf03' : operator && operator.color_codes && operator.color_codes.selected_off_bg,
						}}
					>
						{offices.map((item, index) => (
							<li
								onClick={() => onSelect(item)}
								className="cursor-pointer  office__item"
								key={index}
								style={getDynamicStyling(item, index)}
							>

								{operator && operator.operator_name === 'jeldres' ?
									(<span
										className="office__name font11 new-tabs"
										style={
											item.active
												? {
													color: getActiveColor(),
													borderBottom:
														operator.operator_name === 'erbuc'
															? '3px solid #fff'
															: operator.operator_name === 'jeldres'
																? '2px solid #ecdf03' : `3px solid ${operator &&
																operator.color_codes &&
																operator.color_codes.secondary_off_bg}`,
												}
												: {
													borderBottom:
														operator.operator_name === 'erbuc'
															? '3px solid #fff' :
															operator.operator_name === 'jeldres'
																? '0px solid #fff' :
																`3px solid ${operator &&
																operator.color_codes &&
																operator.color_codes.selected_off_bg}`,
													color: getInActiveColor(),
													// color:
													// operator &&
													// operator.color_codes &&
													// operator.color_codes.secondary_text_color
												}
										}
									>
										{item.title}
									</span>) : (<span
										className="office__name font11 "
										style={
											item.active
												? {
													color: getActiveColor(),
													borderBottom:
														operator.operator_name === 'erbuc'
															? '3px solid #fff'
															: operator.operator_name === 'jeldres'
																? '2px solid #ecdf03' : `3px solid ${operator &&
																operator.color_codes &&
																operator.color_codes.secondary_off_bg}`,
												}
												: {
													borderBottom:
														operator.operator_name === 'erbuc'
															? '3px solid #fff' :
															operator.operator_name === 'jeldres'
																? '0px solid #fff' :
																`3px solid ${operator &&
																operator.color_codes &&
																operator.color_codes.selected_off_bg}`,
													color: getInActiveColor(),
													// color:
													// operator &&
													// operator.color_codes &&
													// operator.color_codes.secondary_text_color
												}
										}
									>
										{item.title}
									</span>)
								}
							</li>
						))}
					</ul>
					<div className="office__map">
						<div className="office__map-view">
							<GoogleMapReact
								bootstrapURLKeys={{ key: AppData.MAP_API_KEY }}
								center={{
									lat: parseFloat(latLong.lat),
									lng: parseFloat(latLong.long),
								}}
								defaultZoom={7}
							>
								<AnyReactComponent
									lat={parseFloat(latLong.lat)}
									lng={parseFloat(latLong.long)}
									img="/assets/bahia/General/pin.png"
								/>
								{/* <Marker
                  position={{ lat: parseFloat(latLong.lat), lng: parseFloat(latLong.long) }}
                  icon={{
                    url: 'https://developers.google.com/maps?hl=pt-br',
                    // anchor: new google.maps.Point(5, 58),
                  }}
                /> */}
							</GoogleMapReact>
						</div>

						<SelectedOffice selectedOffice={selectedOffice} operator={operator} />
					</div>
				</div>
			</div>
		</div >
	);
};

const SelectedOffice = ({ selectedOffice, operator }) => {
	return (
		<div className="office__map-details">
			<div className="office__map-details-text">
				{selectedOffice && selectedOffice.subOffices && selectedOffice.subOffices.length
					? selectedOffice.subOffices.map((value, index) => {
						return (
							<div key={index} className="selected-office">
								<div
									className="terminal"
									style={{
										borderBottom: `3px solid ${operator &&
											operator.color_codes &&
											operator.color_codes.primary_color}`,
									}}
								>
									{value.terminal}
								</div>
								{value.phone ? (
									<div className="phone">
										<img
											src={getIcons('OfficePhoneIcon', operator)}
											alt=""
											className="icon-size icon-left "
											style={{ width: '18px', marginRight: '5px' }}
										/>
										{value.phone}
									</div>
								) : null}

								{value.address ? (
									<div className="address">
										<img
											src={getIcons('Destination', operator)}
											alt=""
											className="icon-size icon-left "
											style={{ marginRight: '5px' }}
										/>
										{value.address}
									</div>
								) : null}
							</div>
						);
					})
					: null}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFiveOfficeSection);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFiveOfficeSection.js